export default __webpack_public_path__ + "static/media/Image-8.8e1d63fa.png";